import * as api from '../api/index'
import { AUTH } from './constants'

const homeByRole = (role) => (role === 'corporate' ? '/corporate/dashboard' : '/dashboard')

export const signin = (formData, openSnackbar, setLoading) => async (dispatch) => {
  try {
    const { data } = await api.signIn(formData)
    dispatch({ type: AUTH, data })
    openSnackbar('Connexion réussie')
    window.location.href = homeByRole(data?.result?.role)
  } catch (error) {
    openSnackbar(error?.response?.data?.message)
    setLoading(false)
  }
}

export const forgot = (formData) => async () => {
  try {
    await api.forgot(formData)
  } catch (error) {
    console.log(error)
  }
}

export const reset = (formData, history) => async () => {
  try {
    await api.reset(formData)
    history.push('/dashboard')
  } catch (error) {
    alert(error)
  }
}
